var _path, _path2, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 74,
    viewBox: "0 0 94 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6925 26.5175C76.302 26.127 75.6688 26.127 75.2783 26.5175L70.7315 31.0643C70.341 31.4549 70.341 32.088 70.7315 32.4785L76.6228 38.3699H26.336C25.7837 38.3699 25.336 38.8176 25.336 39.3699V45.5921C25.336 46.1444 25.7837 46.5921 26.336 46.5921H76.2791L70.7315 52.1398C70.341 52.5303 70.341 53.1635 70.7315 53.554L75.2783 58.1008C75.6688 58.4913 76.302 58.4913 76.6925 58.1008L91.7771 43.0163C92.1676 42.6257 92.1676 41.9926 91.7771 41.6021L76.6925 26.5175Z",
    fill: "#F8F8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2783 26.5175L74.5712 25.8104V25.8104L75.2783 26.5175ZM76.6925 26.5175L75.9854 27.2246L75.9854 27.2246L76.6925 26.5175ZM70.7315 31.0643L71.4386 31.7714V31.7714L70.7315 31.0643ZM70.7315 32.4785L71.4386 31.7714V31.7714L70.7315 32.4785ZM76.6228 38.3699V39.3699H79.037L77.3299 37.6628L76.6228 38.3699ZM76.2791 46.5921L76.9862 47.2992L78.6934 45.5921H76.2791V46.5921ZM70.7315 52.1398L71.4386 52.8469V52.8469L70.7315 52.1398ZM70.7315 53.554L71.4386 52.8469V52.8469L70.7315 53.554ZM75.2783 58.1008L74.5712 58.8079V58.8079L75.2783 58.1008ZM76.6925 58.1008L77.3996 58.8079V58.8079L76.6925 58.1008ZM91.7771 43.0163L91.07 42.3092H91.07L91.7771 43.0163ZM91.7771 41.6021L91.07 42.3092L91.07 42.3092L91.7771 41.6021ZM75.9854 27.2246V27.2246L77.3996 25.8104C76.6186 25.0293 75.3522 25.0293 74.5712 25.8104L75.9854 27.2246ZM71.4386 31.7714L75.9854 27.2246L74.5712 25.8104L70.0244 30.3572L71.4386 31.7714ZM71.4386 31.7714V31.7714L70.0244 30.3572C69.2433 31.1383 69.2433 32.4046 70.0244 33.1856L71.4386 31.7714ZM77.3299 37.6628L71.4386 31.7714L70.0244 33.1856L75.9157 39.077L77.3299 37.6628ZM26.336 39.3699H76.6228V37.3699H26.336V39.3699ZM26.336 39.3699V37.3699C25.2314 37.3699 24.336 38.2653 24.336 39.3699H26.336ZM26.336 45.5921V39.3699H24.336V45.5921H26.336ZM26.336 45.5921H26.336H24.336C24.336 46.6967 25.2314 47.5921 26.336 47.5921V45.5921ZM76.2791 45.5921H26.336V47.5921H76.2791V45.5921ZM71.4386 52.8469L76.9862 47.2992L75.572 45.885L70.0244 51.4327L71.4386 52.8469ZM71.4386 52.8469V52.8469L70.0244 51.4327C69.2433 52.2137 69.2433 53.4801 70.0244 54.2611L71.4386 52.8469ZM75.9854 57.3937L71.4386 52.8469L70.0244 54.2611L74.5712 58.8079L75.9854 57.3937ZM75.9854 57.3937H75.9854L74.5712 58.8079C75.3522 59.589 76.6186 59.589 77.3996 58.8079L75.9854 57.3937ZM91.07 42.3092L75.9854 57.3937L77.3996 58.8079L92.4842 43.7234L91.07 42.3092ZM91.07 42.3092V42.3092L92.4842 43.7234C93.2652 42.9423 93.2652 41.676 92.4842 40.8949L91.07 42.3092ZM75.9854 27.2246L91.07 42.3092L92.4842 40.8949L77.3996 25.8104L75.9854 27.2246Z",
    fill: "#2C2828"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1057_10652",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.669312,
    y: 7.16113,
    width: 45.3548,
    height: 14.3226,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.669312,
    y: 7.16113,
    width: 45.3548,
    height: 14.3226,
    rx: 1,
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 4,
    mask: "url(#path-3-inside-1_1057_10652)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1057_10652",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.24995,
    width: 38.1936,
    height: 9.54839,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.24995,
    width: 38.1936,
    height: 9.54839,
    rx: 1,
    fill: "#F8F8F8",
    stroke: "#2C2828",
    strokeWidth: 4,
    mask: "url(#path-4-inside-2_1057_10652)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_1057_10652",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.44351,
    y: 19.0967,
    width: 35.8064,
    height: 54.9032,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.44351,
    y: 19.0967,
    width: 35.8064,
    height: 54.9032,
    rx: 1,
    fill: "#D0D0D0",
    stroke: "#2C2828",
    strokeWidth: 4,
    mask: "url(#path-5-inside-3_1057_10652)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.89154,
    y: 34.2588,
    width: 28.7778,
    height: 23.2963,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83598 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6323 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2249 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0212 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8175 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6138 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.41 8.90723V19.8702",
    stroke: "#2C2828",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIn);
export default __webpack_public_path__ + "static/media/transfer-in.217ae64c326e39d89dd5ebf66b4b8de9.svg";
export { ForwardRef as ReactComponent };